import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, LoadingController, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import * as $ from "jquery";
import { LoginPage } from '../pages/login/login';
import { HomePage } from '../pages/home/home';
import { PerfilPage } from "../pages/perfil/perfil";
import { AuditoriaPage } from "../pages/auditoria/auditoria";
import { MenuController } from 'ionic-angular';
import { ListaUsuariosPage } from "../pages/lista-usuarios/lista-usuarios";
import { ListaUsuariosParceirosPage } from "../pages/lista-usuarios-parceiros/lista-usuarios-parceiros";
import { ListagemEventoPage } from "../pages/listagem-evento/listagem-evento";
import { ListaOperadoresPage } from "../pages/lista-operadores/lista-operadores";
import { ListaParceirosPage } from "../pages/lista-parceiros/lista-parceiros";
import { ListaExcluidosPage } from "../pages/lista-excluidos/lista-excluidos";
import { CarteirinhaPage } from "../pages/carteirinha/carteirinha";
import { AuxilioFormPage } from "../pages/auxilio-form/auxilio-form";
import { AuxilioListPage } from "../pages/auxilio-list/auxilio-list";
import { LivroCaixaPage } from "../pages/livro-caixa/livro-caixa";
import { PlebiscitoPage } from "../pages/plebiscito/plebiscito";


import { Http } from '@angular/http';
import config from "../config/config";
import { AgendamentoPage } from '../pages/agenda/agendamento/agendamento';
import { CadastroAgendaPage } from "../pages/agenda/cadastro-agenda/cadastro-agenda";
import { LiberarDiasPage } from "../pages/agenda/liberar-dias/liberar-dias";
import { ListadeSolicitacoesPage } from "../pages/agenda/listade-solicitacoes/listade-solicitacoes";
import { SiapePage } from '../pages/siape/siape';
import { EventoPage } from "../pages/evento/evento";
import { BancosPage } from "../pages/bancos/bancos";
import { ecAgendamentoPage } from '../pages/espaco-cultural/agendamento/ecagendamento';
import { ecCadastroAgendaPage } from "../pages/espaco-cultural/cadastro-agenda/eccadastro-agenda";
import { ecLiberarDiasPage } from "../pages/espaco-cultural/liberar-dias/ecliberar-dias";
import { ecListadeSolicitacoesPage } from "../pages/espaco-cultural/listade-solicitacoes/eclistade-solicitacoes";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = LoginPage;
  pages: any = null;
  id = sessionStorage.getItem("id");
  permissao: boolean;
  adm: boolean;
  parceiro: boolean;
  grupo: any;
  usuario: any;
  dados: any;
  dependentes: any;
  inscricao: boolean;
  fore:any
  // navCtrl: NavController;
  bemvindo = {
    nome: null,
    bemVindo : '',
  };
  active = false
  constructor(platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    public loadingCtrl: LoadingController,
    public _http: Http,
    public event: Events,
    public menuCtrl: MenuController,

  ) {

    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

      statusBar.styleDefault();
      splashScreen.hide();
    });
    event.subscribe('atualizar', (user, time) => {
      // user and time are the same arguments passed in `events.publish(user, time)`
      this.ngOnInit()
    });

  }


  ngOnInit() {
    this.id = sessionStorage.getItem("id");
    this.getUsuario();
   
    
  }
  goToLogout() {
    sessionStorage.clear();
    window.location.reload(true);
  }
  getUsuario() {

    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    let env = { id: sessionStorage.getItem("id") };
    

    if (env.id != null) {



      this._http
        .post(config.urlAPI + "usuario/unico", env, {})
        .map(res => res.json())
        .toPromise()
        .then(res => {
          loading.dismiss();

          if (res.grupold == 3 || res.grupold == 2) {
            this.permissao = true;
          }
          if (res.grupold == 2) {
            this.adm = true;
            this.pages = [
              { title: "Home", component: HomePage, id: 'home' },
              {
                title: "Agenda", component: AgendamentoPage, id: 'agenda', sub: [
                  { title: "Cadastro", component: CadastroAgendaPage, id: 'c-agenda' },
                  { title: "Liberar horários", component: LiberarDiasPage, id: 'l-horarios' },
                  { title: "Solicitar Atendimento", component: AgendamentoPage, id: 's-atendimento' },
                  { title: "Solicitações", component: ListadeSolicitacoesPage, id: 'solicitacoes' },
                ]
              },
              {
                title: "Sindicalizados", component: ListaUsuariosPage, id: 'usuario', sub: [
                  { title: 'Lista', component: ListaUsuariosPage, id: 'lista-usuario' },
                  { title: 'Lista de Excluidos', component: ListaExcluidosPage, id: 'excluidos' }
                ]
              },
              // { title: "Lista de Sindicalizados (Parceiros)", component: ListaUsuariosParceirosPage,id:'parceiros'  },
              { title: "Evento Lista", component: ListagemEventoPage, id: 'evento' },
              {
                title: "Espaco Cultural", component: ecAgendamentoPage, id: 'ecagenda', sub: [
                  { title: "Cadastro", component: ecCadastroAgendaPage, id: 'ecc-agenda' },
                  { title: "Liberar dia para agendamento", component: ecLiberarDiasPage, id: 'ecl-horarios' },
                  { title: "Solicitar agendamento", component: ecAgendamentoPage, id: 'ecs-atendimento' },
                  { title: "Solicitações", component: ecListadeSolicitacoesPage, id: 'ecsolicitacoes' },
                ]
              },
              { title: "Lista de Operados", component: ListaOperadoresPage, id: 'operadores' },
              { title: "Gerar Siape", component: SiapePage, id: 'siape' },    
              { title: "Gerenciar Bancos", component: BancosPage, id: 'bancos' },    

              { title: "Lista de Parceiros", component: ListaParceirosPage, id: 'lista-parceiros' },
              { title: "Carteirinha", component: CarteirinhaPage, id: 'carteirinha' },
              { title: "Cadastro Auxílio", component: AuxilioFormPage, id: 'c-auxilio' },
              { title: "Lista de Auxílio", component: AuxilioListPage, id: 'l-auxilio' },
              { title: "Livro Caixa", component: LivroCaixaPage, id: 'l-caixa' },

              { title: "Perfil", component: PerfilPage, id: 'perfil' },
              { title: "Auditoria", component: AuditoriaPage, id: 'auditoria' },

            ];
          } else if (res.grupold == 4) {
            this.parceiro = true;
            this.pages = [
              { title: "Home", component: HomePage },
              { title: "Lista de Sindicalizados", component: ListaParceirosPage },
              { title: "Perfil", component: PerfilPage },
            ];

          } 
          else if (res.grupold == 7) {
            this.parceiro = true;
            this.pages = [
              { title: "Home", component: HomePage },
              { title: "Evento Lista", component: ListagemEventoPage },
            ];

          }
          else if (res.grupold == 1) {
            this.pages = [
              { title: "Home", component: HomePage },
              { title: "Evento", component: EventoPage },
              { title: "Carteirinha", component: CarteirinhaPage },
              {
                title: "Espaco Cultural", component: ecAgendamentoPage, id: 'ecagenda', sub: [
                  { title: "Solicitar agendamento", component: ecAgendamentoPage, id: 'ecs-atendimento' },
                  { title: "Solicitações", component: ecListadeSolicitacoesPage, id: 'ecsolicitacoes' },
                ]
              },
              { title: "Solicitar Atendimento", component: AgendamentoPage, id: 's-atendimento' },
              { title: "Solicitações", component: ListadeSolicitacoesPage, id: 'solicitacoes' },
              { title: "Perfil", component: PerfilPage },
            ];
          } else if (res.grupold == 3) {
            this.pages = [
              { title: "Home", component: HomePage },
              {
                title: "Agendamento", component: AgendamentoPage, id: 'agenda', sub: [
                  { title: "Liberar horários", component: LiberarDiasPage, id: 'l-horarios' },
                  { title: "Solicitar Atendimento", component: AgendamentoPage, id: 's-atendimento' },
                  { title: "Solicitações", component: ListadeSolicitacoesPage, id: 'solicitacoes' },
                ]
              },
              {
                title: "Usuário", component: ListaUsuariosPage, sub: [
                  { title: 'Lista', component: ListaUsuariosPage },
                  { title: 'Lista de Excluidos', component: ListaExcluidosPage }
                ]
              },
              { title: "Lista de Usuários Parceiros", component: ListaUsuariosParceirosPage },
              { title: "Evento Lista", component: ListagemEventoPage },

              // { title: "Evento Lista", component: ListagemEventoPage },
              { title: "Lista de Operados", component: ListaOperadoresPage },
              { title: "Lista para Parceiros", component: ListaParceirosPage },
              { title: "Carteirinha", component: CarteirinhaPage },
              { title: "Cadastro Auxílio", component: AuxilioFormPage },
              { title: "Lista de Auxílio", component: AuxilioListPage },
              { title: "Perfil", component: PerfilPage },
              { title: "Auditoria", component: AuditoriaPage },

            ];
          } else if (res.grupold == 5) {
            this.pages = [
              { title: "Home", component: HomePage },
              {
                title: "Agendamento", component: AgendamentoPage, id: 'agenda', sub: [
                  { title: "Liberar horários", component: LiberarDiasPage, id: 'l-horarios' },
                  { title: "Solicitar Atendimento", component: AgendamentoPage, id: 's-atendimento' },
                  { title: "Solicitações", component: ListadeSolicitacoesPage, id: 'solicitacoes' },
                ]
              },
            ];
          }
          this.grupo = res.grupold;
          this.usuario = res;
          this.dados = res.dados;
          this.dependentes = res.dependentes;
          if (
            (res.dados.foto != "//public/perfildefault.jpg" &&
              res.dados.emDia == "S") ||
            this.permissao == true
          ) {
            this.inscricao = true;
          }
          this.tratarBemvindo();

        })
        .catch(error => {
          loading.dismiss();
        });
    }else{
    loading.dismiss();
    }
  }
  openPage(page) {



    if (page.sub != undefined) {
      
      
      $('.SubMenu').removeClass('active')
      $('#' + page.id + ' .SubMenu').addClass('active')
    } else {
      this.active = false;
      $('.SubMenu').removeClass('active')
      this.menuCtrl.close();


      this.nav.setRoot(page.component, {
        usuario: this.usuario,
        dados: this.dados,
        grupo: this.grupo,
        dependentes: this.dependentes,
        bemVindo: this.bemvindo.bemVindo,
        usuarioIdAuditoria: this.usuario.id
      });
    }
  }
  tratarBemvindo() {
    this.bemvindo.bemVindo = this.usuario.nome.split(" ")[0];
    if (this.usuario.grupold === 2) {
      this.bemvindo.bemVindo += " - Administrador";
    } else if (this.usuario.grupold === 1) {
      this.bemvindo.bemVindo += " - Sindicalizado";
    } else if (this.usuario.grupold === 4) {
      this.bemvindo.bemVindo += " - Funcionário";
    } else {
      this.bemvindo.bemVindo += " - Estagiário";

    }
  }




}




// WEBPACK FOOTER //
// ./src/app/app.component.ts